import { render, staticRenderFns } from "./DeletePaymentRecord.vue?vue&type=template&id=a93c4c5e&"
import script from "./DeletePaymentRecord.vue?vue&type=script&lang=js&"
export * from "./DeletePaymentRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports